import type { CSSProperties, ReactNode } from 'react'
import type { SVGProps } from 'react'

export interface IconProps extends SVGProps<SVGSVGElement> {
  size?: number
  color?: string
}

export const Icon = ({ children, size = 18, className = '', style, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    vectorEffect="non-scaling-stroke"
    className={className}
    style={{ flexShrink: 0, ...style }}
    {...rest}
  >
    {children}
  </svg>
)
